import { getLegacyOpenThermSensors, getLegacyRadioSensorsConfig } from './utils';
import { LegacyDevice } from 'console/device/device';
import { isRadioThermometer } from '../../thermometers/legacy/utils';
export function getLegacySensors(device) {
    const { rf_status, ot_enabled } = device;
    //Нужно только для того, чтобы достать пределы значений (в rf_status их нет)
    const radio_thermometers = LegacyDevice.active_thermometers(device?.thermometers || []).filter(isRadioThermometer);
    const open_therm_sensors = ot_enabled ? getLegacyOpenThermSensors(device) : [];
    const radio_sensors = rf_status
        ? getLegacyRadioSensorsConfig(rf_status, radio_thermometers)
        : [];
    return [...radio_sensors, ...open_therm_sensors];
}
